export default "__VITE_ASSET__9qQ1Jv2h__"